import { Tooltip } from 'antd'
import { UnlockOutlined } from '@ant-design/icons'
import React from 'react'
import { IQuotaBoxLockedProps } from './types'
import IntlMessages from '../utils/IntlMessages'
import { LeaveDisplayFormatEnum, QuotaDisplayFormatEnum } from '../../types/display-in-days-hours'
import { IQuotaAmount, QuotaUnits } from '../../types/leave-policy'
import { useIntl } from 'react-intl'
import { getRawOrFormattedQuota } from '../../functions/get-days-or-hours'

const QuotaBox = ({
  isLocked,
  title,
  lockedTooltip,
  dataTestId,
  footer,
  value,
  valueUnits,
  displayFormat = QuotaDisplayFormatEnum.formatted,
}: IQuotaBoxLockedProps): React.ReactElement => {
  return (
    <Tooltip title={isLocked ? lockedTooltip : null}>
      <div className={`quota quota-box ${isLocked ? 'lock' : ''}`}>
        {isLocked && (
          <div className='quota-card-lock'>
            <div><UnlockOutlined /><br /><IntlMessages id='components.userLeaveQuotas.unlock' /></div>
          </div>
        )}
        <div className='quota-box-title' data-testid={`${dataTestId}-title`}>{title}</div>
        <div className='quota-box-value' data-testid={`${dataTestId}-value`}>{formatValue(value, displayFormat, valueUnits)}</div>
        <div className='quota-box-footer' data-testid={`${dataTestId}-footer`}>{footer}</div>
      </div>
    </Tooltip>
  )
}

function formatValue(value: IQuotaAmount, displayFormat: QuotaDisplayFormatEnum, valueUnits: QuotaUnits): React.ReactElement {
  const { formatMessage } = useIntl()
  return <>{
    getRawOrFormattedQuota(value, formatMessage, displayFormat === QuotaDisplayFormatEnum.raw, valueUnits, LeaveDisplayFormatEnum.short)
  }</>
}

export default QuotaBox
